import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'schedulecourse-dialog-component',
    styleUrls: ['schedulecourse.dialogcomponent.css'],
    templateUrl: 'schedulecourse.dialogcomponent.html',
})
export class ScheduleCourseDialogComponent implements OnInit {
    canceltext: string;
    message: string;
    oktext: string;
    title: string;
    ReferenceNumber: string;
    CountyTaught: boolean;
    IsForAltReference: boolean;

    constructor(
        public dialogRef: MatDialogRef<ScheduleCourseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: _ScheduleCourseDialogOptions
    ) {
        this.canceltext = data.CancelText || 'Cancel';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'Run Report';
        this.title = data.TitleText || 'Choose Report Options';
        this.ReferenceNumber = data.ReferenceNumber || '';
        this.CountyTaught = data.CountyTaught != null ? data.CountyTaught : null;
        this.IsForAltReference = data.IsForAltReference != null ? data.IsForAltReference : false;
    }

    ngOnInit() {}

    // #region Cancel Handler Method

    CancelHandler() {
        this.dialogRef.close(null);
    }

    // #endregion

    // #region OK Handler Method

    OkHandler() {
        this.dialogRef.close({
            ReferenceNumber: this.ReferenceNumber,
            CountyTaught: this.CountyTaught,
        });
    }

    // #endregion
}

// #region Custom Classes

// #region Schedule Course Dialog Options Class

export class _ScheduleCourseDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    ReferenceNumber?: string;
    CountyTaught?: boolean;
    IsForAltReference?: boolean;
}

// #endregion

// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/schedulecourse/schedulecourse.dialogcomponent.ts